import { render, staticRenderFns } from "./AppSwitcherIcon.vue?vue&type=template&id=73e264f2"
import script from "./AppSwitcherIcon.vue?vue&type=script&lang=js"
export * from "./AppSwitcherIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports